export default "/institutions/nubank.svg";